import qs from 'qs'
import Table2Excel from 'table2excel.js'
export default {
  data () {
    return {
      currentPage: 1,
      pageSize: 500,
      params: {},
      fixedParams: {},
      list: [],
      total: 0,
      selectRows: [],
      exporting: false,
      loading: false
    }
  },
  methods: {
    fetchList () {
      if (this.pageSize > 0) {
        this.params.start = (this.currentPage - 1) * this.pageSize
        this.params.limit = this.pageSize
      }
      this.loading = true
      this.$http.get('/dbapi/' + this.sqlcode, {
        params: {
          ...this.params,
          ...this.fixedParams
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(data => {
        this.loading = false
        this.list = data.list
        this.total = data.total
        if (this.selectRow && this.selectRow.id) {
          let srs = this.list.filter(r => r.id === this.selectRow.id)
          if (srs.length === 1) {
            this.selectRow = srs[0]
          }
        }
      }).catch(() => this.loading = false)
    },
    handleSelectionChange (val) {
      this.selectRows = val
    },
    search (params) {
      this.params = params
      this.currentPage = 1
      this.fetchList()
    },
    pageChange (val) {
      this.currentPage = val
      this.fetchList()
    },
    pageSizeChange (val) {
      this.pageSize = val
      this.fetchList()
    },
    excel () {
      new Table2Excel('#excelTable').export()
    },
    print (showDescription = 0, windowUrl) {
      let win = this.$open('/loading')
      this.$http.post('/dbapi/list_params_insert', {
        params: JSON.stringify(this.params),
        show_description: showDescription
      }).then(result => {
        win.location = windowUrl + '/' + result.insertId
      })
    },
    refresh () {
      this.fetchList()
    }
  }
}
